import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import './styles.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

/**
 * ★ ลงทะเบียน service worker เพื่อให้ติดตั้งเป็นแอปได้ ★
 *
 * พอติดตั้งแล้วแถบที่อยู่เว็บจะหายไป — พนักงานได้พื้นที่จอคืนและ
 * ไม่เผลอกดออกจากแอประหว่างขาย
 *
 * ล้มเหลวก็ไม่เป็นไร แอปยังใช้งานได้ปกติทุกอย่าง
 */
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => {
      /* เปิดผ่าน http ที่ไม่ใช่ localhost จะลงทะเบียนไม่ได้ — ไม่กระทบการขาย */
    });
  });
}
